import { createAction, props } from '@ngrx/store';

export abstract class SharedActions {
  static getPreviousUrl = createAction('[SharedActions] Get Previous URL');
  static setPreviousUrl = createAction('[SharedActions] Set Previous URL', props<{ previousUrl: string }>());
}
